<template>
    <div class="board-filter">
        <!-- <b-form @submit.prevent> -->
          <b-row class="d-flex align-items-center justify-content-between">
            <!-- Keyword -->
            <b-col cols="4">
              <div class="text-container keyword-label-area">
                <label for="Keyword">Keyword</label>
                <div>
                  <b-input-group-append>
                    <b-form-select size="sm" class="sub-options" v-model="conditions.scope" 
                    :options="keywordScopeOptions">
                        
                    </b-form-select>
                  </b-input-group-append>
                </div>
              </div>
              <b-input-group>
                <b-form-input @keyup.enter="search" v-model="conditions.keyword" placeholder="Keyword" />
              </b-input-group>
            </b-col>
            <!-- /keyword -->

            <!-- /hierarchy -->
            <b-col cols="2">
              <div class="filter-search-button-wrapper">
                <div class="hierarchy-button-area">
                  <span>Hierarchy</span>
                  <input type="checkbox" id="hierarchyInput" v-model="conditions.hierarchy" :disabled="isDisableHierarchyButton"/>
                  <label for="hierarchyInput" class="hierarchy-toggle-button"></label>
                </div>

                <!-- <button class="hierarchy-switch" :style="hierarchySwitchStyle" @click="handleChangeHierarchy">
                  <b-icon :icon="conditions.hierarchy ? 'list-nested' : 'list'" font-scale="2"/>
                </button> -->

                <button class="filter-search-button" @click="search">
                    Search
                    <!-- <b-icon icon="search"/> -->
                </button>
              </div>
            </b-col>
            <!-- /search-button -->
          </b-row>

          <b-col class="d-flex justify-content-center" style="flex-grow: 0;">
            <div class="board-filter-line"></div>
          </b-col>
        <!-- </b-form> -->
        <!-- /Button Group -->
        <!-- TODO -->
      </div>
</template>
<script>

export default {
    name: 'BoardFilter',
    created() {
        if(!this.conditions.scope) {
          this.$store.commit('board/setScope', this.keywordScopeOptions[0]);
        }
    },
    data() {
        return {

        }
    },
    computed: {
      keywordScopeOptions() {
          return this.$store.getters['board/keywordScope'];
      },
      conditions() {
          return this.$store.getters['board/conditions'];
      },
      hierarchySwitchStyle() {
        return this.conditions.hierarchy ? {backgroundColor: '#DDDDE3', color: 'black'} : {backgroundColor: '#2E2E38', color: 'white'};
      },
      sortOptions() {
        return this.$store.getters['board/sort'];
      },
      isDisableHierarchyButton() {
        return this.sortOptions.length > 0;
      }
    },
    methods: {
      search() {
          return this.$emit('click:searchButton');
      },
      handleChangeHierarchy() {
        this.conditions.hierarchy = !this.conditions.hierarchy;
        this.search();
      }
    }
}
</script>
<style scoped>
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

* {
  font-family: "NanumGothic";
}

.filter-search-button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
}

.hierarchy-button-area {
  display: flex; 
  justify-content: 
  space-between; 
  align-items: center;
}

.hierarchy-button-area:has(#hierarchyInput:disabled) {
  opacity: 0.6;
}

.hierarchy-toggle-button {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 1.3em;
  background-color: #ccc;
  border-radius: 20px;
  margin: 0;
  margin-left: 0.3em;
}

.hierarchy-toggle-button::after {
  content: '';
  position: absolute;
  width: 0.9em;
  height: 0.9em;
  border-radius: 50%;
  background-color: white;
  top: 50%;
  left: 5%;
  transform: translateY(-50%);
  transition: 0.2s;
}

.hierarchy-toggle-button::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  transition: 0.2s;
}
#hierarchyInput {
  display: none;
}

#hierarchyInput:checked + .hierarchy-toggle-button::after {
  transform: translateX(100%) translateY(-50%);
}
#hierarchyInput:checked + .hierarchy-toggle-button::before {
  background-color: #142459;
  border: #142459;
}


.filter-search-button {
    background-color: rgb(46, 46, 56);
    border: none;
    border-radius: 10px;
    color: rgb(255, 230, 0);
    font-weight: bold;
    width: 7em;
    margin-left: 1em;
}

/* select */
.post-list .custom-select {
    padding: 0.533rem 2.1rem 0.533rem 1.066rem;
    height: 2.666rem;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background-color: #FFF;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-position: calc(100% - 12px) 9px;
    background-size: 20px 20px;
    background-repeat: no-repeat;
    font-family: 'NanumGothic';
    color: #2E2E38;
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
  }
  .post-list .custom-select.sub-options {
    padding: 0.233rem 2.1rem 0.233rem 1.066rem;
    background-position: calc(100% - 12px) 4px;
    height: 2.1rem;
    font-size: 1rem;
    margin-bottom: 0.2rem;
  }
  
  .post-list .chatter-list .custom-select:focus {
    border-color: #E7E7EE;
    box-shadow: unset;
  }

  .board-filter-line {
    position: relative;
    display: block;
    width: 100%;
    margin: 20px 0;
  }
  
  .board-filter-line::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #DDDDE3;
    transform: translateY(-30%);
  }

  .board-filter .hierarchy-switch {
    border: none;
    border-radius: 10px;
  }

</style>

